import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function MfaGate({ children }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const publicPaths = ['/verify-access', '/privacy', '/privacy-policy', '/terms', '/terms-and-conditions'];
  if (!loading && user?.mfa_required && !publicPaths.includes(pathname)) {
    return <Navigate to="/verify-access" replace />;
  }
  return children;
}
